import type { CooldownStore, CooldownEntry } from "@yjsgames/cooldown";

/**
 * @yjsgames/cooldown `CooldownStore` Port의 프로젝트 어댑터 (DIP).
 * 쿨타임 entry를 `SaveData.cooldowns` 맵에 위임 저장한다 — idleblade `CooltimeSaveEntry` 역할.
 *
 * 맵을 직접 받지 않고 접근자(`read`)로 받아, GameScene이 로드 시 `cooldowns`를 reassign해도
 * stale 참조가 되지 않게 한다 (항상 현재 맵을 읽고 in-place 변경 → persist가 그대로 직렬화).
 * SaveDataResetStore와 동형 패턴.
 */
export class SaveDataCooldownStore implements CooldownStore {
  constructor(private readonly read: () => Record<string, CooldownEntry>) {}

  getEntry(key: string): CooldownEntry | undefined {
    return this.read()[key] as CooldownEntry | undefined;
  }

  setEntry(key: string, entry: CooldownEntry): void {
    this.read()[key] = entry;
  }

  removeEntry(key: string): void {
    delete this.read()[key];
  }
}
